<template>
    <div class="flex w-full flex-col items-center justify-center gap-4">
        <DsIcon
            class="text-content-primary"
            :icon
            size="lg"
        />

        <div class="text-center">
            <p class="mb-1 text-content-lg font-medium text-content-primary">{{ title }}</p>
            <p class="text-content-md text-content-secondary">{{ subtitle }}</p>
        </div>
        <slot />
    </div>
</template>

<script setup lang="ts">
import type { DsIconProps } from '@/components/design-system/DsIcon.vue';
import DsIcon from '@/components/design-system/DsIcon.vue';

interface DsSelectEmptyStateProps {
    icon: DsIconProps['icon'];
    title: string;
    subtitle: string;
}

defineProps<DsSelectEmptyStateProps>();
</script>
